import { render, staticRenderFns } from "./ItemPhotosSection.vue?vue&type=template&id=3bab7c4a&scoped=true"
import script from "./ItemPhotosSection.vue?vue&type=script&lang=js"
export * from "./ItemPhotosSection.vue?vue&type=script&lang=js"
import style0 from "./ItemPhotosSection.vue?vue&type=style&index=0&id=3bab7c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab7c4a",
  null
  
)

export default component.exports